import { Injectable } from '@angular/core';
import {
  VesselHotoForm,
  VesselHotoFormDraftBody,
  VesselHotoFormSubmitBody,
  VesselHotoFormType,
  VesselHotoSetList,
} from '@app/domain/entities/vessel-hoto-form.entity';
import { Observable } from 'rxjs';
import { BaseApiService } from '../api-services';
import { VESSEL_HOTO_MOBILE_ENDPOINTS } from '../constants';
import { LoggerService } from '../logger';

@Injectable({ providedIn: 'root' })
export class VesselHotoFormService {
  readonly SERVICE_NAME = 'VesselHotoFormService';

  constructor(
    private readonly _api: BaseApiService,
    private readonly _logger: LoggerService
  ) {}

  getForm(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    setNo?: number | null
  ): Observable<VesselHotoForm> {
    this._logger.info(this.SERVICE_NAME, 'getForm', [
      vesselActivityId,
      formType,
      setNo,
    ]);
    const url =
      formType === 'handover'
        ? VESSEL_HOTO_MOBILE_ENDPOINTS.HANDOVER_FORM(vesselActivityId)
        : VESSEL_HOTO_MOBILE_ENDPOINTS.TAKEOVER_FORM(vesselActivityId);
    return this._api.get<VesselHotoForm>(url, setNo ? { setNo } : undefined);
  }

  getSets(vesselActivityId: number): Observable<VesselHotoSetList> {
    this._logger.info(this.SERVICE_NAME, 'getSets', [vesselActivityId]);
    return this._api.get<VesselHotoSetList>(
      VESSEL_HOTO_MOBILE_ENDPOINTS.SETS(vesselActivityId)
    );
  }

  startNewSet(vesselActivityId: number): Observable<VesselHotoSetList> {
    this._logger.info(this.SERVICE_NAME, 'startNewSet', [vesselActivityId]);
    return this._api.post<VesselHotoSetList>(
      VESSEL_HOTO_MOBILE_ENDPOINTS.SETS(vesselActivityId),
      null,
      { isCms: true }
    );
  }

  submitForm(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    body: VesselHotoFormSubmitBody
  ): Observable<void> {
    this._logger.info(this.SERVICE_NAME, 'submitForm', [
      vesselActivityId,
      formType,
    ]);
    const url =
      formType === 'handover'
        ? VESSEL_HOTO_MOBILE_ENDPOINTS.HANDOVER_SUBMIT(vesselActivityId)
        : VESSEL_HOTO_MOBILE_ENDPOINTS.TAKEOVER_SUBMIT(vesselActivityId);
    return this._api.post<void>(url, body, { isCms: true });
  }

  saveDraft(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    body: VesselHotoFormDraftBody
  ): Observable<void> {
    this._logger.info(this.SERVICE_NAME, 'saveDraft', [
      vesselActivityId,
      formType,
    ]);
    const url =
      formType === 'handover'
        ? VESSEL_HOTO_MOBILE_ENDPOINTS.HANDOVER_DRAFT(vesselActivityId)
        : VESSEL_HOTO_MOBILE_ENDPOINTS.TAKEOVER_DRAFT(vesselActivityId);
    return this._api.post<void>(url, body, { isCms: true });
  }
}
